import "./RibbonTab.css";

import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";

import { getStorageUserSettings } from "slices/user_adv";

const RibbonTab = ({ name, appName, route, allowDisplay, icon, isActive, callback, styles }) => {
	const location = useLocation();
	const userSettings = useSelector(getStorageUserSettings);

	if (!allowDisplay(location.pathname)) return null;
	if (userSettings?.ribbonTab?.hidden?.includes(appName)) return null;

	return (
		<Link
			to={route}
			style={styles}
			className={isActive(location.pathname) ? "ribbon-tab  ribbon-tab-active" : "ribbon-tab"}
			onClick={() => {
				if (callback) callback();
			}}
		>
			{icon} {name}
		</Link>
	);
};

export default RibbonTab;
